module.exports = __webpack_public_path__ + "img/accessory_hat_11.a0474a43.svg";